import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  divider: {
    position: "relative",
    padding: "10px",
    margin: "10px 0 20px",
  },
  dividerHr: {
    borderColor: theme.palette.events.grayShade1,
    borderWidth: "1px",
  },
  orText: {
    position: "absolute",
    left: "50%",
    top: "15%",
    transform: "translateX(-50%)",
    padding: "0 10px",
    backgroundColor: "#fff",
    fontSize: "14px",
    color: theme.palette.events.lightBlack,
  },
}));
